import styled from "styled-components"

interface AlertStatusBadgeProps {
  status: string
  className?: string
}

const StyledBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  padding: 2px 8px;
  border-radius: 20px;

  ${({ $status }) => {
    switch ($status) {
      case "frozen":
        return `
          border: 1px solid #2db2cb;
          background: var(--accent-subtle);
          color: #165964;
        `
      case "acknowledged":
        return `
          border: 1px solid var(--text-link);
          background: var(--status-info-subtle);
          color: #4338ca;
        `
      default:
        return ` 
          border: 1px solid #14b8a6;
          background: #dffbf4;
          color: #115e59;
        `
    }
  }}
`

const getStatusLabel = (status: string) => {
  switch (status.toLowerCase()) {
    case "frozen":
      return "FROZEN"
    case "acknowledged":
      return "ACKNOWLEDGED"
    default:
      return "ACTIVE"
  }
}

export const AlertStatusBadge = ({ status, className }: AlertStatusBadgeProps) => {
  return (
    <StyledBadge $status={status.toLowerCase()} className={className}>
      {getStatusLabel(status)}
    </StyledBadge>
  )
}
